export default function rebox (element) {
  $(element).rebox({selector: 'figure a'})
}
